import { trans } from '@lingoda/i18n';
import { Box, Button, Img, Paper, Typography } from '@lingoda/ui';
import { ArrowRightIcon } from '@lingoda/ui/icons/lingodaIcons';
import type { ReactNode } from 'react';

export interface ConversionCardProps {
    label?: string;
    header: string;
    body: ReactNode;
    image: string;
    buttonLabel?: string;
    onCtaClick: () => void;
    stepper?: ReactNode;
}

const ConversionCard = ({
    label,
    header,
    body,
    buttonLabel,
    image,
    onCtaClick: onNextClick,
    stepper,
}: ConversionCardProps) => (
    <Paper variant="outlined">
        <Box p={[2, 4]} display="flex" alignItems="center" flexDirection="column" gap={2}>
            <Box
                display="flex"
                alignItems="center"
                flexDirection="column"
                maxWidth="calc(65% + 32px)"
            >
                {label && (
                    <Typography variant="subtitle2" htmlColor="primary.main" gutterBottom>
                        {label}
                    </Typography>
                )}

                <Typography variant="h2" textAlign="center" gutterBottom>
                    {header}
                </Typography>

                <Typography
                    component={typeof body === 'string' ? 'p' : 'div'}
                    variant="body2"
                    textAlign="center"
                    htmlColor="text.secondary"
                >
                    {body}
                </Typography>
            </Box>

            {stepper && <Box>{stepper}</Box>}

            <Box my={1}>
                <Paper variant="outlined">
                    <Img src={image} />
                </Paper>
            </Box>

            <Box mb={1}>
                <Button color="primary" variant="contained" onClick={onNextClick}>
                    {buttonLabel || (
                        <Box display="inline-flex" alignItems="center" gap={0.5}>
                            {trans('next', {}, 'student-common')}
                            <ArrowRightIcon size={16} />
                        </Box>
                    )}
                </Button>
            </Box>
        </Box>
    </Paper>
);

export default ConversionCard;
